import { createBrowserRouter } from 'react-router-dom';

import { Layout } from '../components/common/Layout';
import { adminLayoutChildren } from './routes/admin';
import { mainLayoutChildren } from './routes/main';
import { publicRoutes } from './routes/public';

export const router = createBrowserRouter([
  // Main application routes
  publicRoutes,
  // Protected routes with main Layout
  {
    Component: Layout,
    children: [...mainLayoutChildren, ...adminLayoutChildren],
  },
]);
